import { GetApp } from "../../App"
import { BlockField } from "../../Components/Block"
import { ShipSingleRowDataItem } from "../../Components/ShipSingleRowDataItem"
import { IShipDataOtherEquipment } from "../../Types"

interface ShipDataOtherEquipmentViewProps {
  data: IShipDataOtherEquipment;
  editable: boolean;
  index: number;
  onEdited?: () => void;
  removeEquipment: () => void;
}

export function ShipDataOtherEquipmentView({ data, editable, index, onEdited, removeEquipment }: ShipDataOtherEquipmentViewProps) {
  const app = GetApp();
  const _t = app.getT("ShipDataView");
  const namePrefix = `otherEquipments[${index}].`;
  const formEditable = editable;

  return (
    <ShipSingleRowDataItem namePrefix={namePrefix} id={data.id} rowClassName="block-row-last" onRemove={removeEquipment}>
      <BlockField>
        <textarea name={`${namePrefix}equipment`} defaultValue={data.equipment} rows={4}readOnly={!formEditable} onChange={onEdited}></textarea>
      </BlockField>
    </ShipSingleRowDataItem>
  );
}
